// Single source of truth for icon URLs. Vite turns each `import` of a PNG
// in src/ into a hashed asset URL, so this stays valid in dev and prod.

import diceUrl from "../icons/dice.png";
import flipHUrl from "../icons/flip-horizontal.png";
import flipVUrl from "../icons/flip-vertical.png";
import recomposeUrl from "../icons/recompose.png";
import siblingsUrl from "../icons/siblings-to-palette.png";
import createGroupUrl from "../icons/create-group.png";
import ungroupUrl from "../icons/ungroup.png";
import deleteUrl from "../icons/delete.png";
import exportCanvasUrl from "../icons/export-canvas.png";
import exportSelectionUrl from "../icons/export-selection.png";
import eyeOpenUrl from "../icons/eye-open.png";
import eyeClosedUrl from "../icons/eye-closed.png";
import lockedUrl from "../icons/locked.png";
import unlockedUrl from "../icons/unlocked.png";
import starUrl from "../icons/star.png";

const ICONS = {
  dice: diceUrl,
  "flip-horizontal": flipHUrl,
  "flip-vertical": flipVUrl,
  recompose: recomposeUrl,
  "siblings-to-palette": siblingsUrl,
  "create-group": createGroupUrl,
  ungroup: ungroupUrl,
  delete: deleteUrl,
  "export-canvas": exportCanvasUrl,
  "export-selection": exportSelectionUrl,
  "eye-open": eyeOpenUrl,
  "eye-closed": eyeClosedUrl,
  locked: lockedUrl,
  unlocked: unlockedUrl,
  star: starUrl,
};

export default function Icon({ name, size = 24, alt, className = "" }) {
  const src = ICONS[name];
  if (!src) return null;
  return (
    <img
      src={src}
      alt={alt ?? name}
      width={size}
      height={size}
      draggable={false}
      className={`pointer-events-none inline-block shrink-0 select-none ${className}`}
      style={{ imageRendering: "auto" }}
    />
  );
}
